// Single source of truth for "is this visitor logged in?".
//
// The route guard on protected pages and the navbar must answer this the same way.
// When they disagreed (guard on the token, UI on a stored flag), a session that lost
// its token still looked logged in while every protected page pushed the visitor
// away. Deriving the answer from the token makes that state impossible.
//
// Written without optional chaining on purpose: this repo builds with react-scripts
// 1.1.4, whose Babel does not support it.

export const selectUser = state => (state && state.AuthReducer ? state.AuthReducer.user : undefined)

export const selectAccessToken = state => {
  const user = selectUser(state)
  return (user && user.accessToken) || undefined
}

export const selectIsAuthenticated = state => Boolean(selectAccessToken(state))



// WEBPACK FOOTER //
// ./src/selectors/authSelector.js